import Navbar from '../components/navbar';
import ReviewHighlight from '../components/homepage/reviewHighlight';
import AboutMERL from '../components/homepage/aboutMERL';
import Footer from '../components/footer';
import '../App.scss';

const Home = () => {
    return (
		<div className="App">
			<header>
				<Navbar></Navbar>
			</header>
		  
			<body>
				{/* <TopStudios/> */}
				<AboutMERL/>
				<ReviewHighlight
					titles={"When They See Us, Captain Marvel, Fleabag-s2, Joker"}
					sectionName={"Featured Reviews"}/>
				<div className='white' >
					<br/><br/><br/>	
				</div>
				<ReviewHighlight
					titles={"Pose-s3, Hacks-s1, Succession-s2, Sex Education-s2"}
					sectionName={"Highest-Rated Media"}/>
				<div className='white' >
					<br/><br/><br/>	
				</div>
				<ReviewHighlight
						titles={"Toy Story 4, Venom: Let There Be Carnage, 1917, Normal People-s1"}
						sectionName={"Lowest-Rated Media"}/>
				{/* <Collections/> */}
				{/* <Articles/> */}
				
				<Footer/>
			</body>
		</div>
	  );
}

export default Home;
